import React, { Component } from 'react'
import {
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  Button
} from 'reactstrap'
import { Prompt } from 'react-router-dom'
import EditableCard from '../../components/EditableCard'
import Auth from '../../modules/Auth'
import { get } from '../../modules/API'

class ViewEditProfile extends Component {
  constructor(props) {
    super(props)

    this.state = {
      profile: {},
      faces: [],
      addFace: false,
      experiences: [],
      addExperience: false,
      editingMode: false,
      loaded: false
    }

    this.setEditingMode = this.setEditingMode.bind(this)
    this.addFace = this.addFace.bind(this)
    this.showAddFace = this.showAddFace.bind(this)
    this.cancelAddFace = this.cancelAddFace.bind(this)
    this.addExperience = this.addExperience.bind(this)
    this.showAddExperience = this.showAddExperience.bind(this)
    this.cancelAddExperience = this.cancelAddExperience.bind(this)
    this.deleteFace = this.deleteFace.bind(this)
    this.deleteExperience = this.deleteExperience.bind(this)
    this.updateModel = this.updateModel.bind(this)
  }

  componentDidMount() {
    if (Auth.isUserAuthenticated()) {
      get(`sales-profiles/${this.props.match.params.id}`)
      .then(data => {
        this.setState(prevState => {
          // let faces = (data.faces || []).map(el => {
          //   if (el.mandatory_member && !this.found) {
          //     this.found = true
          //   } else {
          //     el.mandatory_member = false
          //   }

          //   return el
          // }, { found: false })

          let faces = (data.faces || []).sort((a, b) => {
            return b.mandatory_member ? 1 : 0
          })

          return {
            ...prevState,
            loaded: true,
            profile: data || {},
            faces: faces,
            experiences: data.customer_experiences || []
          }
        })
      })
    }
  }

  setEditingMode(editingMode) {
    this.setState({ editingMode })
  }

  updateModel(model, data) {
    this.setState(prevState => {
      let newData

      if (model !== 'profile') {
        newData = prevState[model].map(el => {
          if (el.id === data.id) {
            return data
          } else {
            if (model === 'faces' && data.mandatory_member) {
              el.mandatory_member = false
            }

            return el
          }
        })
      } else {
        newData = data
      }

      return {
        [model]: newData
      }
    })
  }

  addFace(face) {
    this.setState(prevState => {
      return {
        faces: prevState.faces.concat(face),
        addFace: false
      }
    })
  }

  showAddFace() {
    this.setState({ addFace: true })
  }

  cancelAddFace() {
    this.setState({ addFace: false })
  }

  deleteFace(id) {
    this.setState(prevState => {
      return {
        faces: prevState.faces.filter(el => el.id !== id)
      }
    })
  }

  addExperience(experience) {
    this.setState(prevState => {
      return {
        experiences: prevState.experiences.concat(experience),
        addExperience: false
      }
    })
  }

  showAddExperience() {
    this.setState({ addExperience: true })
  }

  cancelAddExperience() {
    this.setState({ addExperience: false })
  }

  deleteExperience(id) {
    this.setState(prevState => {
      return {
        experiences: prevState.experiences.filter(el => el.id !== id)
      }
    })
  }

  render() {
    const profile_cards = [
      {
        cardTitle: 'Allgemeine Informationen',
        cardSubtitle: 'Hinterlegen Sie allgemeine Informationen zu Ihrem Standort und ermöglichen Sie Hausbauinteressenten dadurch den direkten Kontakt.',
        fetchData: {
          method: 'patch',
          endpoint: `sales-profiles/${this.props.match.params.id}`,
        },
        cardFields: [
          {
            id: 'office_profile_picture',
            fieldLabel: 'Titelbild Ihres Büros',
            fieldSublabel: 'Zeigen Sie Interessenten ein Foto von Ihrem Team, Musterhaus oder Vertriebsbüro',
            fieldType: 'single_image',
            fieldValue: this.state.profile.office_profile_picture,
            imageAspectRatio: 4/3
          }, {
            id: 'office_type',
            fieldLabel: 'Art Ihres Büros',
            fieldType: 'radio',
            fieldValue: this.state.profile.office_type,
            fieldValues: [
              { 'model_house': 'Musterhaus' },
              { 'selling_agency': 'Vertriebsbüro' },
              { 'headquarter': 'Zentrale' },
              { 'factory': 'Werk' },
              { 'sample_provisioning': 'Bemusterungszentrum' }
            ]
          }, {
            id: 'office_name',
            fieldLabel: 'Name Ihres Büros',
            fieldType: 'text',
            fieldValue: this.state.profile.office_name,
            fieldRequired: true,
            fieldCharLimit: 64
          }, {
            id: 'company',
            fieldLabel: 'Firma Ihres Büros',
            fieldSublabel: 'Geben Sie hier die verantwortliche Firma für Ihr Büro an. (Im Falle einer Franchise-Struktur bitte die Firma des Franchise-Nehmers)',
            fieldType: 'text',
            fieldValue: this.state.profile.company
          }, {
            id: 'address_line_1',
            fieldLabel: 'Straße und Hausnummer',
            fieldType: 'text',
            fieldValue: this.state.profile.address_line_1,
            fieldRequired: true
          }, {
            id: 'address_line_2',
            fieldLabel: 'Adresszusatz',
            fieldType: 'text',
            fieldValue: this.state.profile.address_line_2
          }, {
            id: 'postal_code',
            fieldLabel: 'Postleitzahl',
            fieldType: 'text',
            fieldValue: this.state.profile.postal_code,
            fieldRequired: true
          }, {
            id: 'city',
            fieldLabel: 'Stadt',
            fieldType: 'text',
            fieldValue: this.state.profile.city,
            fieldRequired: true
          }, {
            id: 'office_phone',
            fieldLabel: 'Telefonnummer',
            fieldType: 'text',
            fieldValue: this.state.profile.office_phone
          }, {
            id: 'website',
            fieldLabel: 'Website Ihres Büros',
            fieldSublabel: 'Verlinken Sie hier optional die Website Ihres Büros. (Die allgemeine Website Ihres Unternehmens brauchen Sie nicht extra anzugeben)',
            fieldType: 'text',
            fieldValue: this.state.profile.website
          }
        ]
      }, {
        cardTitle: 'Öffnungszeiten',
        cardSubtitle: 'Erfassen Sie die Öffnungszeiten Ihres Standorts und erleichtern Sie so erfolgreiche Kontaktaufnahmen und Vor Ort Besuche.',
        fetchData: {
          method: 'patch',
          endpoint: `sales-profiles/${this.props.match.params.id}`,
        },
        cardFields: [].concat(...[
          'monday',
          'tuesday',
          'wednesday',
          'thursday',
          'friday',
          'saturday',
          'sunday'
        ].map(day => {
            return [].concat(...['opening_hours', 'lunch_break'].map(period => {
              return ['start', 'end', 'status'].map(end => {
                if (end === 'status' && period === 'lunch_break') {
                  return false
                }

                return {
                  id: `${period}_${day}_${end}`,
                  fieldType: 'text',
                  fieldLabel: `${period}_${day}_${end}`,
                  fieldValue: `${this.state.profile[`${period}_${day}_${end}`]}`
                }
              }).filter(el => el !== false)
            }))
          })),
        customCard: 'opening-times'
      }, {
        cardTitle: 'Services',
        cardSubtitle: 'Zeigen Sie die von Ihnen angebotenen Dienstleistungen und überzeugen Sie Interessenten durch Ihr individuelles Serviceangebot.',
        fetchData: {
          method: 'patch',
          endpoint: `sales-profiles/${this.props.match.params.id}`,
        },
        cardFields: [
          {
            id: 'services',
            fieldValue: this.state.profile.services
          }
        ],
        customCard: 'services'
      }, {
        cardTitle: 'Beschreibung Ihres Büros',
        cardSubtitle: 'Beschreiben Sie Ihren Standort in Wort und Bild und überzeugen Sie über einen persönlichen Eindruck.',
        fetchData: {
          method: 'patch',
          endpoint: `sales-profiles/${this.props.match.params.id}`,
        },
        cardFields: [
          {
            id: 'description',
            fieldType: 'textarea',
            fieldLabel: 'Beschreibungstext zu Ihrem Büro',
            fieldSublabel: 'Vermitteln Sie Interessenten ein besseres Bild von sich und schaffen Sie Vertrauen. Beschreiben Sie z.B. wie lange Sie schon am Markt tätig sind, wie viele Häuser Sie gebaut haben, worin Ihre Beratungsschwerpunkte bestehen und was Sie besonders macht. Veranschaulichen Sie Ihre Beschreibung zusätzlich z.B. mit Bildern Ihres Teams und Standorts sowie mit Eindrücken aus Beratungssituationen und von positiven Kundenerfahrungen.',
            fieldValue: this.state.profile.description,
            textareaRows: 10
          },
          ...[1,2,3,4,5,6,7,8,9,10].map(el => {
            return {
              id: `description_image_${el}`,
              fieldLabel: `Bild #${el}`,
              fieldSublabel: el === 1 ? 'Zeigen Sie Interessenten weitere Fotos von Ihrem Team, Musterhaus oder Vertriebsbüro (maximal 10 Bilder)' : null,
              fieldType: 'single_image',
              fieldValue: this.state.profile[`description_image_${el}`],
              imageAspectRatio: 3/2
            }
          }).filter(el => el !== null)
        ]
      }
    ]

    const faces_cards = this.state.faces.map((face, index) => {
      return {
        id: face.id,
        cardTitle: face.mandatory_member ? 'Hauptansprechpartner' : 'Team Mitglied',
        isDeletable: !face.mandatory_member,
        fetchData: {
          method: 'patch',
          endpoint: `sales-profiles/${this.props.match.params.id}/faces/${face.id}`,
        },
        cardDeleteMessage: 'Sind Sie sicher, dass Sie dieses Team Mitglied löschen wollen?',
        cardFields: [
          {
            id: 'avatar',
            fieldType: 'single_image',
            fieldValue: face.avatar,
            imageAspectRatio: 1
          }, {
            id: 'gender',
            fieldType: 'select',
            fieldValue: face.gender,
            fieldValues: [
              { id: 'm', value: 'Herr' },
              { id: 'w', value: 'Frau' },
              { id: 'i', value: 'Keine Angabe' }
            ],
            fieldLabel: 'Anrede',
            fieldRequired: true
          }, {
            id: 'first_name',
            fieldType: 'text',
            fieldValue: face.first_name,
            fieldLabel: 'Vorname',
            fieldRequired: true
          }, {
            id: 'last_name',
            fieldType: 'text',
            fieldValue: face.last_name,
            fieldLabel: 'Nachname',
            fieldRequired: true
          }, {
            id: 'position',
            fieldType: 'text',
            fieldValue: face.position,
            fieldLabel: 'Jobtitel',
            fieldPlaceholder: 'z.B. Bauberater, Gebietsleiter'
          }, {
            id: 'phone',
            fieldType: 'text',
            fieldValue: face.phone,
            fieldLabel: 'Telefonnummer'
          }
        ]
      }
    })

    const faces_card_blank = {
        cardTitle: 'Team Mitglied',
        fetchData: {
          method: 'post',
          endpoint: `sales-profiles/${this.props.match.params.id}/faces/`,
        },
        cardDeleteMessage: 'Sind Sie sicher, dass Sie dieses Team Mitglied löschen wollen?',
        cardFields: [
          {
            id: 'avatar',
            fieldType: 'single_image',
            imageAspectRatio: 1
          }, {
            id: 'gender',
            fieldType: 'select',
            fieldValues: [
              { id: 'm', value: 'Herr' },
              { id: 'w', value: 'Frau' },
              { id: 'i', value: 'Keine Angabe' }
            ],
            fieldLabel: 'Anrede',
            fieldRequired: true
          }, {
            id: 'first_name',
            fieldType: 'text',
            fieldLabel: 'Vorname',
            fieldRequired: true
          }, {
            id: 'last_name',
            fieldType: 'text',
            fieldLabel: 'Nachname',
            fieldRequired: true
          }, {
            id: 'position',
            fieldType: 'text',
            fieldLabel: 'Jobtitel',
            fieldPlaceholder: 'z.B. Bauberater, Gebietsleiter'
          }, {
            id: 'phone',
            fieldType: 'text',
            fieldLabel: 'Telefonnummer'
          }
        ]
      }

    const experiences_cards = this.state.experiences.map(experience => {
      return {
        id: experience.id,
        cardTitle: 'Kundenstory',
        fetchData: {
          method: 'patch',
          endpoint: `sales-profiles/${this.props.match.params.id}/customer-experiences/${experience.id}`,
        },
        cardDeleteMessage: 'Sind Sie sicher, dass Sie diese Kundenstory löschen wollen?',
        cardFields: [
          {
            id: 'top_picture',
            fieldType: 'single_image',
            fieldValue: experience.top_picture,
            fieldLabel: 'Titelbild',
            fieldSublabel: 'Ein Bild Ihrer Bauherren macht den Beitrag vertrauenswürdiger und bringt Ihre Arbeit auf eine persönliche Ebene.'
          },
          ...[1,2,3,4,5].map(el => {
            return {
              id: `additional_picture_${el}`,
              fieldLabel: `Weitere Bilder #${el}`,
              fieldSublabel: el === 1 ? 'Potentielle Kunden lassen sich gerne von bereits gebauten Häusern inspirieren (maximal 5 Bilder)' : null,
              fieldType: 'single_image',
              fieldValue: experience[`additional_picture_${el}`],
              imageAspectRatio: 3/2
            }
          }).filter(el => el !== null), {
            id: 'title',
            fieldType: 'text',
            fieldLabel: 'Titel der Kundenstory',
            fieldValue: experience.title,
            fieldCharLimit: 64,
            fieldRequired: true
          }, {
            id: 'video_link_1',
            fieldType: 'text',
            fieldValue: experience.video_link_1,
            fieldLabel: 'Video Einfügen'
          }, {
            id: 'year_of_construction',
            fieldType: 'text',
            fieldValue: experience.year_of_construction,
            fieldLabel: 'Baujahr des Hauses'
          }, {
            id: 'region',
            fieldType: 'text',
            fieldValue: experience.region,
            fieldLabel: 'Stadt/Region in der das Haus gebaut wurde'
          }, {
            id: 'house_name',
            fieldType: 'text',
            fieldValue: experience.house_name,
            fieldLabel: 'Name des Hauses'
          }, {
            id: 'building_owner',
            fieldType: 'text',
            fieldValue: experience.building_owner,
            fieldLabel: 'Name der Bauherren'
          }, {
            id: 'experience_text',
            fieldType: 'textarea',
            fieldValue: experience.experience_text,
            fieldSublabel: 'Ermöglichen Sie Interessenten einen Eindruck davon was es bedeutet erfolgreich mit Ihnen zusammenzuarbeiten. Verwenden Sie einen aussagekräftigen Titel und erwähnen Sie neben Details zu Bauherren und Bauprojekt z.B. die Unterstützung im Planungsprozess, die Erfassung und Verwirklichung von individuellen Wünschen sowie die Betreuung im Rahmen von weitergehenden Serviceleistungen. Geben Sie am besten direkt 2-3 Erfahrungsberichte verschiedener Bauherren an und veranschaulichen Sie diese mit Bildern der Bauherren, des Bauprojekts und weiteren Ereignissen, wie z.B. dem Richtfest. Ein persönlicher positiver Eindruck zahlt sich aus.',
            fieldLabel: 'Die Hausbauerfahrung aus Sicht der Bauherren',
            fieldPlaceholder: 'Fragen Sie Ihre Bauherren, ihre Erfahrung kurz zu beschreiben.',
            textareaRows: 10,
            fieldRequired: true
          }
        ]
      }
    })

    const experiences_card_blank = {
        cardTitle: 'Kundenstory',
        fetchData: {
          method: 'post',
          endpoint: `sales-profiles/${this.props.match.params.id}/customer-experiences/`,
        },
        cardDeleteMessage: 'Sind Sie sicher, dass Sie diese Kundenstory löschen wollen?',
        cardFields: [
          {
            id: 'top_picture',
            fieldType: 'single_image',
            fieldLabel: 'Titelbild',
            fieldSublabel: 'Ein Bild Ihrer Bauherren macht den Beitrag vertrauenswürdiger und bringt Ihre Arbeit auf eine persönliche Ebene.'
          },
          ...[1,2,3,4,5].map(el => {
            return {
              id: `additional_picture_${el}`,
              fieldLabel: `Weitere Bilder #${el}`,
              fieldSublabel: el === 1 ? 'Potentielle Kunden lassen sich gerne von bereits gebauten Häusern inspirieren (maximal 5 Bilder)' : null,
              fieldType: 'single_image',
              imageAspectRatio: 3/2
            }
          }).filter(el => el !== null), {
            id: 'title',
            fieldType: 'text',
            fieldLabel: 'Titel der Kundenstory',
            fieldCharLimit: 64,
            fieldRequired: true
          }, {
            id: 'video_link_1',
            fieldType: 'text',
            fieldLabel: 'Video Einfügen'
          }, {
            id: 'year_of_construction',
            fieldType: 'text',
            fieldLabel: 'Baujahr des Hauses'
          }, {
            id: 'region',
            fieldType: 'text',
            fieldLabel: 'Stadt/Region in der das Haus gebaut wurde'
          }, {
            id: 'house_name',
            fieldType: 'text',
            fieldLabel: 'Name des Hauses'
          }, {
            id: 'building_owner',
            fieldType: 'text',
            fieldLabel: 'Name der Bauherren'
          }, {
            id: 'experience_text',
            fieldType: 'textarea',
            fieldLabel: 'Die Hausbauerfahrung aus Sicht der Bauherren',
            fieldPlaceholder: 'Fragen Sie Ihre Bauherren, ihre Erfahrung kurz zu beschreiben.',
            textareaRows: 10,
            fieldRequired: true
          }
        ]
      }

    const face_selector_card = {
        cardTitle: 'Hauptansprechpartner bestimmen',
        cardSubtitle: 'Jedes Team hat eine Ansprechperson. Diese Person sieht der Interessent auf fertighaus.de sowohl auf den Häuserdetailseiten als auch auf der Profilseite Ihres Büros als "Ansprechpartner/Ansprechpartnerin in der Nähe".' + (this.state.faces.length < 1 ? ' Bitte legen Sie zunächst Ihre Teammitglieder an und bestimmen Sie dann den/die Hauptansprechpartner(-in).' : ''),
        fetchData: {
          method: 'patch',
          endpoint: `sales-profiles/${this.props.match.params.id}/faces/face_id`,
          force: true,
          endpointOptions: {
            isDynamic: true,
            field: 'face_id'
          }
        },
        disableEdit: this.state.faces.length < 1,
        cardFields: [
          {
            id: 'face_id',
            fieldType: 'select',
            fieldValue: this.state.faces.filter(el => el.mandatory_member)[0] ?
                        this.state.faces.filter(el => el.mandatory_member)[0].id : null,
            fieldValues: this.state.faces.map(face => {
              return {
                id: face.id,
                value: `${face.first_name ? face.first_name : ''} ${face.last_name ? face.last_name : ''}`
              }
            }),
            fieldLabel: 'Hauptansprechpartner'
          }, {
            id: 'mandatory_member',
            fieldType: 'hidden',
            fieldValue: true
          }
        ]
      }

    const selectFaceBlock = <EditableCard
                              userInfo={this.props.userInfo}
                              {...face_selector_card}
                              getEditingMode={this.state.editingMode}
                              setEditingMode={this.setEditingMode}
                              updateModel={this.updateModel}
                            />

    const addFacesBlock = this.state.addFace &&
      <EditableCard
        userInfo={this.props.userInfo}
        {...faces_card_blank}
        getEditingMode={this.state.editingMode}
        setEditingMode={this.setEditingMode}
        newCard={true}
        addFace={this.addFace}
        cancelAddFace={this.cancelAddFace}
      />

    const addExperiencesBlock = this.state.addExperience &&
      <EditableCard
        userInfo={this.props.userInfo}
        {...experiences_card_blank}
        getEditingMode={this.state.editingMode}
        setEditingMode={this.setEditingMode}
        newCard={true}
        addExperience={this.addExperience}
        cancelAddExperience={this.cancelAddExperience}
      />

    const viewProfileLive = this.state.profile.live_url &&
      <Row className="mb-4">
        <Col>
          <Button tag="a" color="primary" block className="btn-wrappable" href={this.state.profile.live_url} target="_blank">
            Profil auf Fertighaus.de ansehen
          </Button>
        </Col>
      </Row>

    return this.state.loaded && (
      <div className="animated fadeIn">
        <Prompt
            when={this.state.editingMode}
            message={`Änderungen verwerfen?`}
          />
        {viewProfileLive}
        <Row className="mb-4">
          <Col>
            {profile_cards.map((el, index) => {
              return <EditableCard
                userInfo={this.props.userInfo}
                key={`profile_card_${index}`}
                {...el}
                getEditingMode={this.state.editingMode}
                setEditingMode={this.setEditingMode}
                updateModel={this.updateModel}
              />})
            }
          </Col>
        </Row>
        <Row className="mb-4">
          <Col>
            <h2>Team</h2>
            <p>Geben Sie Ihrem Auftritt ein Gesicht. Ergänzen Sie Ansprechpartner inkl. Kontaktdaten und ermuntern Sie dadurch zur direkten Kontaktaufnahme.</p>
            {selectFaceBlock}
            {faces_cards.length > 0 && faces_cards.map(el => {
              return <EditableCard
                userInfo={this.props.userInfo}
                key={`face_card_${el.id}`}
                id={el.id}
                {...el}
                getEditingMode={this.state.editingMode}
                setEditingMode={this.setEditingMode}
                updateModel={this.updateModel}
                isDeletable={el.isDeletable}
                deleteFace={this.deleteFace}
              />})
            }
            {addFacesBlock}
            <Button color="primary" onClick={this.showAddFace}>Team Mitglied hinzufügen</Button>
          </Col>
        </Row>
        <Row className="mb-4">
          <Col>
            <h2>Kundenstories</h2>
            <p>Fügen Sie hier die positiven Erfahrungsberichte vergangener Kunden ein und stärken Sie so das Vertrauen potentieller Neukunden.</p>
            {experiences_cards.length > 0 && experiences_cards.map(el => {
              return <EditableCard
                userInfo={this.props.userInfo}
                key={`experience_card_${el.id}`}
                id={el.id}
                {...el}
                getEditingMode={this.state.editingMode}
                setEditingMode={this.setEditingMode}
                updateModel={this.updateModel}
                isDeletable={true}
                deleteExperience={this.deleteExperience}
              />})
            }
            {addExperiencesBlock}
            <Button color="primary" onClick={this.showAddExperience}>Kundenstories hinzufügen</Button>
          </Col>
        </Row>
        {viewProfileLive}
      </div>
    )
  }
}

export default ViewEditProfile



// WEBPACK FOOTER //
// ./src/views/Profiles/ViewEditProfile.js